import $ from 'init/jquery'
import { OLD_BROWSER_VERSIONS } from 'es6/constants'
import { isDesktop } from '../init/is-desktop'

/**
 * Получает набор конфигураций для разных типов устройств из конфига.
 * @param {Object} bowser
 * @returns {Object} версии для различных типов устаревших браузеров
 */
export const getCurrentOsVersions = bowser => {
  let isDesktopBrowser
  if (!isDesktop) {
    isDesktopBrowser = $('.old-browser-content').data('device-desktop')
  } else {
    isDesktopBrowser = isDesktop
  }
  switch (bowser.osname) {
    case 'Android':
      return OLD_BROWSER_VERSIONS.mobileAndroid
    case 'iOS':
      return OLD_BROWSER_VERSIONS.mobileIOS
    default:
      return isDesktopBrowser ? OLD_BROWSER_VERSIONS.desktop : OLD_BROWSER_VERSIONS.mobile
  }
}

/**
 * Получает информацию о браузерах Opera Mini и Opera Mobile и их версиях,
 * возвращает информацию о поддержке браузера
 * @param {Object} bowser
 * @param {Object} navigator
 * @returns {Object}/false данные о браузере или false если такие барузеры не найдены
 */
export const getOperaMiniOrMobileOptions = (bowser, navigator) => {
  let ua = navigator.userAgent,
    tem,
    browserOptions,
    configVersion
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    if (ua.indexOf('Opera Mini') > -1) {
      browserOptions = { name: 'operamini', version: tem[1] }
      if (bowser.osname === 'Android') {
        configVersion = OLD_BROWSER_VERSIONS.mobileAndroid.operamini
      }
      if (bowser.osname === 'iOS') {
        configVersion = OLD_BROWSER_VERSIONS.mobileIOS.operamini
      }
    } else if (ua.indexOf('Opera Mobi') > -1) {
      browserOptions = { name: 'operamobi', version: tem[1] }
      if (bowser.osname === 'Android') {
        configVersion = OLD_BROWSER_VERSIONS.mobileAndroid.operamobile
      }
    }
    if (configVersion && browserOptions.version >= parseInt(configVersion)) {
      browserOptions.isUnsupported = false
    } else {
      if (browserOptions && browserOptions.name) {
        browserOptions.isUnsupported = true
      }
    }
    return browserOptions
  }
  return false
}
